import { gsap } from "gsap";

class Modal {
  constructor(modalWrapper, modal, btn, closeBtn) {
    this.modalWrapper = modalWrapper;
    this.modal = modal;
    this.btn = btn;
    this.closeBtn = closeBtn;
    this.state = false;
    this.listener();
  }
  animation(target, reverse = false) {
    const tl = gsap.timeline({ paused: true });
    tl.fromTo(
      target,
      {
        display: "none",
        opacity: 0,
      },
      {
        display: "flex",
        opacity: 1,
      }
    );
    tl.fromTo(
      this.modal,
      {
        y: reverse ? -100 : 100,
      },
      {
        y: 0,
      },
      "="
    );
    if (reverse) {
      tl.reverse(true);
    } else {
      tl.play();
    }
  }

  close() {
    this.animation(this.modalWrapper, true);
    this.state = false;
  }

  open() {
    this.animation(this.modalWrapper);
    this.state = true;
  }

  listener() {
    document.addEventListener("click", (e) => {
      if ((this.state && e.target.closest(this.closeBtn)) || (this.state && !e.target.closest(".modal"))) {
        this.close();
      }
      if (!this.state && e.target.closest(this.btn)) {
        this.open();
      }
    });
  }
}

new Modal(document.querySelector(".modal-wrapper"), document.querySelector(".modal"), ".js-open-modal", ".modal__close");
